<template>
  <div class="mt-6 mb-16 pb-16">
    <v-stepper
    class="mb-16 pb-16"
      v-model="step"
      vertical
    >
      <div
        v-for="(q, i) in questions"
        :key="i"
      >
        <v-stepper-step
          :step="i + 1"
          :complete="isSelected(i)"
          :id="`step${i}`"
        >
          {{ $t(`EVALUATE.${q.question}`) }}
        </v-stepper-step>

        <v-stepper-content :step="i + 1">
          {{ q.description }}

          <div>
            <FormRange
              class="my-12"
              v-if="q.component === 'range'"
              :ref="`component${i}`"
              @select="setSelected(i); next();"
            />
            <FormBool
              class="my-12"
              v-else-if="q.component === 'bool'"
              :ref="`component${i}`"
              @select="setSelected(i); next();"
            />
            <FormMultiple
              class="my-0 py-0"
              v-else-if="q.component === 'multiple'"
              :options="q.options"
              prefix="EVALUATE."
              :ref="`component${i}`"
              @select="setSelected(i)"
            />
            <span v-else>
              {{ q.component }}
            </span>
          </div>
        </v-stepper-content>
      </div>
    </v-stepper>

    <div class="fixed-buttons px-4 d-flex justify-center">
      <v-row class="buttons-container">
        <v-col v-if="step > 1">
          <v-btn
            text
            block
            @click="prev()"
          >
            {{ $t('EVALUATE.PREV') }}
          </v-btn>
        </v-col>
        <v-col>
          <!-- :disabled="!isSelected(step - 1)" -->
        <BaseButton
          color="primary"
          :disabled="!canGoNext"
          @click="next()"
        >
          {{ $t('EVALUATE.NEXT') }}
        </BaseButton>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style type="text/css">
html.no-scroll {
  overflow: hidden;
}
</style>

<style scoped>
.fixed-buttons {
  background-color: white;
  border-top: 1px solid #f1f0ee;
  bottom: 0;
  left: 0px;
  position: fixed;
  width: 100%;
}

.buttons-container {
  max-width: 500px;
}
</style>

<script>
import FormBool from '@/components/form/FormBool.vue';
import FormMultiple from '@/components/form/FormMultiple.vue';
import FormRange from '@/components/form/FormRange.vue';

export default {
  name: 'FormPost',
  components: {
    FormBool,
    FormMultiple,
    FormRange,
  },
  data: () => ({
    step: 1,
    // check: false,
    selected: [],
  }),
  computed: {
    questions() {
      return this.$store.state.evaluate.questions;
    },
    canGoNext() {
      return this.selected[this.step - 1];
    },
  },
  methods: {
    component(i) {
      return (this.$refs[`component${i}`] && this.$refs[`component${i}`][0]) || {};
    },
    setSelected(i) {
      const selected = [...this.selected];
      selected[i] = true;
      this.selected = selected;
      // this.next();
    },
    isSelected(i) {
      return (i < this.selected.length);
    },
    submitStep(i) {
      const comp = this.component(i);
      this.$store.dispatch('evaluate/submit', {
        prepost: 'post',
        question: i,
        answer: comp.selected,
      });
    },
    next() {
      this.submitStep(this.step - 1);
      this.step += 1;

      // Was last question?
      if (this.step - 1 === this.questions.length) {
        this.$store.dispatch('settings/store', { postEvaluated: true });
        this.$track('post_eval_complete', 'evaluation');
        return this.$router.replace({ name: 'home' });
      }

      this.scroll();

      const cond = this.questions[this.step - 1].condition;
      if (cond) {
        let { index } = cond;
        if (index === 'prev') {
          index = this.step - 2;
        }

        const comp = this.component(index);
        if (!comp || comp.selected !== cond.value) {
          this.step += 1;
        }
      }

      return true;
      // return this.scroll();
    },
    prev() {
      if (this.step >= 0) {
        this.step -= 1;
      }
      this.scroll();
    },
    scroll() {
      let to = this.step - 2;
      if (to < 0) {
        to = 0;
      }
      this.$vuetify.goTo(`#step${to}`);
    },
  },
  created() {
    document.querySelector('html').classList.add('no-scroll');
  },
  beforeDestroy() {
    document.querySelector('html').classList.remove('no-scroll');
  },
};
</script>
